import {
    createContext,
    useState,
    useEffect,
    useContext,
    useCallback,
} from "react";
import "./variables.css";

const THEME_VERSION = 1;
const DEFAULT_THEME = "light";

const ThemeContext = createContext({
    theme: DEFAULT_THEME,
    toggleTheme: () => {},
});

export function AppThemeProvider({ children }) {
    const [theme, setTheme] = useState(() => {
        const theme = localStorage.getItem("theme");

        if (theme === `light@v${THEME_VERSION}`) return "light";
        if (theme === `dark@v${THEME_VERSION}`) return "dark";

        return DEFAULT_THEME;
    });

    const handleThemeChange = useCallback((theme) => {
        document.documentElement.setAttribute("data-theme", theme);
        localStorage.setItem("theme", `${theme}@v${THEME_VERSION}`);
    }, []);

    const toggleTheme = useCallback(() => {
        setTheme((prevTheme) => {
            const theme = prevTheme === "light" ? "dark" : "light";
            handleThemeChange(theme);
            return theme;
        });
    }, [handleThemeChange]);

    useEffect(() => {
        handleThemeChange(theme);
    }, [handleThemeChange, theme]);

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
}

export function useAppTheme() {
    return useContext(ThemeContext);
}
